export const clawbackErrors = {
  amount: '',
  target: '',
  claimable_id: '',
}

export const defaultClawback = {
  issuer: '',
  asset_code: '',
  amount: '',
  target: '',
  claimable_id: '',
}
